import {
    ReflectiveInjector, Injector, Provider,
    Injectable, Optional, Inject,
    ComponentFactoryResolver,
    ApplicationRef,
} from '@angular/core';
import {
    DomPortalHost,
} from '@angular/cdk/portal';
import { DOCUMENT } from '@angular/platform-browser';

@Injectable()
export class PortalUtil {
    constructor(
        @Inject(DOCUMENT) private document,
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        @Optional() private injector: Injector) {}

    public resolveInputs(
        provides: Provider[]) {
        const resolved = ReflectiveInjector.resolve(provides);
        return ReflectiveInjector.fromResolvedProviders(
            resolved, this.injector);
    }

    public genHost(injector?: Injector, nativeDom?: any) {
        if (!injector) {
            injector = this.injector;
        }
        if (!nativeDom) {
            nativeDom = this.document.body;
        }
        return new DomPortalHost(
            nativeDom,
            this.componentFactoryResolver,
            this.appRef, injector);
    }
}
